import InvoiceListLayer from "../components/InvoiceListLayer";
import { useEffect, useState } from "react";
import axios from "axios";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";

const InvoiceList = () => {
  return (
    <MasterLayout>
      <Breadcrumb title="Hóa đơn" />
      <InvoiceListLayer />
    </MasterLayout>
  );
};

export default InvoiceList;
